import { Component } from '@angular/core';

@Component({
    selector: '[app-table-cell]',
    templateUrl: './table-cell.component.html',
    styleUrls: ['./table-cell.component.scss'],
    standalone: false
})
export class TableCellComponent {

}
